export default __webpack_public_path__ + "static/media/covid 19.fda80481.pdf";